import { render } from "./OnlineShopping.vue?vue&type=template&id=20bdd35f"
import script from "./OnlineShopping.vue?vue&type=script&lang=js"
export * from "./OnlineShopping.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__